if(!window.customElements.get('collection-signup-form')) {
  window.customElements.define('collection-signup-form', class CollectionSignupForm extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('.collection-signup__form');

      if (!this.form) return;

      this.emailInput = this.form.querySelector('[name="email"]');
      this.newsletterCheckbox = this.form.querySelector('[name="newsletterOptIn"]');
      this.honeyInput = this.form.querySelector('[name="_honey"]');
      this.submitBtn = this.form.querySelector('.collection-signup__submit');
      this.submitLabel = this.submitBtn.querySelector('.collection-signup__submit-label');
      this.spinner = this.submitBtn.querySelector('.collection-signup__spinner');
      this.message = this.form.querySelector('.collection-signup__message');

      this.strings = {
        LABEL_DEFAULT: this.dataset.labelDefault,
        LABEL_LOADING: this.dataset.labelLoading,
        MSG_SUCCESS: this.dataset.msgSuccess,
        MSG_ERROR: this.dataset.msgError,
        MSG_EMPTY: this.dataset.msgEmpty
      };

      console.log(this.form)

      this.form.addEventListener('submit', (event) => this.submitForm(event));
    }


    showMessage(text, type) {
      this.message.textContent = text;
      this.message.className = 'collection-signup__message collection-signup__message--' + type;
      this.message.hidden = false;
    }

    setLoading(loading) {
      this.submitBtn.disabled = loading;
      this.spinner.hidden = !loading;
      this.submitLabel.textContent = loading ? this.strings.LABEL_LOADING : this.strings.LABEL_DEFAULT;
    }

    async submitForm(e) {
        e.preventDefault();
        this.message.hidden = true;
        this.message.className = 'collection-signup__message';

        const email = this.emailInput.value.trim();
        if (!email) {
          showMessage(this.strings.MSG_EMPTY, 'error');
          this.emailInput.focus();
          return;
        }

        const endpoint = this.dataset.endpoint;
        const collectionHandle = this.dataset.collectionHandle;
        const listId = this.dataset.listId;

        this.setLoading(true);

        try {
          const res = await fetch(endpoint, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              email,
              collectionHandle,
              newsletterOptIn: this.newsletterCheckbox ? this.newsletterCheckbox.checked : false,
              listId: listId || undefined,
              _honey: this.honeyInput ? this.honeyInput.value : '',
            }),
          });

          const data = await res.json().catch(() => ({}));

          if (res.ok && data.ok) {
            this.showMessage(this.strings.MSG_SUCCESS, 'success');
            this.form.reset();
          } else {
            this.showMessage(data.error || this.strings.MSG_ERROR, 'error');
          }
        } catch {
          this.showMessage(this.strings.MSG_ERROR, 'error');
        } finally {
          this.setLoading(false);
        }
    }
  });
}
